import { Modal } from 'react-bootstrap';
import React, { useContext, useEffect } from 'react';
import { CustomStepWizardNav } from '../CustomStepWizardNav';
import StepWizard from 'react-step-wizard';
import { EditBranchDevicesStep } from './EditBranchDevicesStep';
import { SelectInventoryItemsStep } from './SelectInventoryItemsStep';
import { TasksContext } from '../../context/TasksContext';
import { PaymentsStep } from './PaymentsStep';

export const CompleteTaskModal = ({
    showModal,
    closeModal,
    refetchTasks,
}: {
    showModal: boolean;
    closeModal: () => void;
    refetchTasks: () => void;
}) => {
    const { selectedTask: task, setTaskDevices, setUsedItems } = useContext(TasksContext);
    useEffect(() => {
        if (!showModal) {
            setTaskDevices([]);
            setUsedItems([]);
        }
    }, [showModal]);

    return (
        <Modal show={showModal && !!task} onHide={closeModal} size='lg' centered className='branches-modal'>
            <div>
                <Modal.Header closeButton />
                <Modal.Body className='p-0'>
                    {task &&
                        (task.taskCategory === 'DEVICE_RETURN' ? (
                            <StepWizard
                                className='step-wizard d-flex flex-column w-100 h-100 align-items-start'
                                nav={<CustomStepWizardNav steps={['returnDevices', 'selectPayments']} isDisabled />}
                                transitions={{
                                    enterRight: '',
                                    enterLeft: '',
                                    exitRight: '',
                                    exitLeft: '',
                                }}
                            >
                                <EditBranchDevicesStep {...{ task, refetchTasks }} />
                                <PaymentsStep {...{ refetchTasks, closeModal }} />
                            </StepWizard>
                        ) : task.taskCategory !== 'PAYMENT' ? (
                            <StepWizard
                                className='step-wizard d-flex flex-column w-100 h-100 align-items-start'
                                nav={
                                    <CustomStepWizardNav
                                        steps={[
                                            task.taskCategory === 'MAINTENANCE'
                                                ? 'editBranchDevices'
                                                : 'addBranchDevices',
                                            'selectInventoryItems',
                                            'selectPayments',
                                        ]}
                                        isDisabled
                                    />
                                }
                                transitions={{
                                    enterRight: '',
                                    enterLeft: '',
                                    exitRight: '',
                                    exitLeft: '',
                                }}
                            >
                                <EditBranchDevicesStep {...{ task, refetchTasks }} />
                                <SelectInventoryItemsStep />
                                <PaymentsStep {...{ refetchTasks, closeModal }} />
                            </StepWizard>
                        ) : (
                            <PaymentsStep {...{ refetchTasks, closeModal }} />
                        ))}
                </Modal.Body>
            </div>
        </Modal>
    );
};
